<template>
  <main>
    <div class="roller"></div>
    <section>
      <div class="title wrap about" v-html="about.text"></div>
    </section>
    <section class="about">
      <div id="about-address" v-html="about.address"></div>
      <div id="about-contact" v-html="about.director"></div>
      <div class="about-production" v-html="about.producer"></div>
    </section>
  </main>
</template>

<script>
export default {
  name: "about",
  metaInfo() {
    return {
      title: "– About"
    };
  },
  computed: {
    about() {
      return this.$store.state.about;
    }
  }
};
</script>

<style lang="scss">
.about {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  padding-left: calc(6 * var(--lh));
  padding-bottom: calc(6 * var(--lh));
  @media only screen and (max-width: 768px) {
    padding-left: calc(2.75 * var(--lh));
    padding-bottom: 1.5rem;
  }
  > div {
    flex: 0 0 33%;
    padding: 1.5rem;
    @media only screen and (max-width: 768px) {
      flex: 0 0 100%;
    }
  }
}
.title.about p {
  margin-bottom: calc(3 * var(--lh));
  @media only screen and (max-width: 768px) {
    margin-bottom: calc(1.9 * var(--lh)) !important;
  }
  &:last-of-type {
    margin-bottom: 0 !important;
  }
}
</style>
